export const config = {
    default: {
        xbAppName: 'myClass',
        cognito: {
            IdentityPoolId: 'us-east-1:3323b5f9-b568-4018-8225-73a34fa68c7d',
            region: 'us-east-1',
        },
        evidently: {
            region: 'us-east-1',
            endpoint: 'https://evidently.us-east-1.amazonaws.com',
        },
        sts: {
            region: 'us-east-1',
            unauthRole: 'arn:aws:iam::843378256785:role/AT2Experiments-Gamma-Comm-GammaAT2ExperimentsCogni-ES4QVUTOGD4G',
            roleSessionName: 'evidently',
        },
        apolloAppUri: 'https://beta.awscloudinstitute.skillbuilder.training.aws.dev/graphql',
    },
    local: {
        cognito: {
            IdentityPoolId: 'us-east-1:c22bb665-5639-48f5-b660-6e15211a596a',
            region: 'us-east-1',
        },
        evidently: {
            region: 'us-east-1',
            endpoint: 'https://evidently.us-east-1.amazonaws.com',
        },
        apolloAppUri: 'http://localhost:3000/graphql',
    },
    beta: {
        cognito: {
            IdentityPoolId: 'us-east-1:c22bb665-5639-48f5-b660-6e15211a596a',
            region: 'us-east-1',
        },
        evidently: {
            region: 'us-east-1',
            endpoint: 'https://evidently.us-east-1.amazonaws.com',
        },
        apolloAppUri: 'https://beta.myclass.skillbuilder.training.aws.dev/graphql',
    },
    gamma: {
        cognito: {
            IdentityPoolId: 'us-east-1:3323b5f9-b568-4018-8225-73a34fa68c7d',
            region: 'us-east-1',
        },
        evidently: {
            region: 'us-east-1',
            endpoint: 'https://evidently.us-east-1.amazonaws.com',
        },
        apolloAppUri: 'https://myclass.skillbuilder.training.aws.dev/graphql',
    },
    prod: {
        apolloAppUri: 'https://myclass.skillbuilder.aws/graphql',
    },
};
